import * as SegmentTracking from '@hotjar/webapp/domains/common/tracking/segment';
import { log } from '@hotjar/insights-common/lib/log';

angular.module('hjApp.tracking').service('Segment', function ($q, $state, $location) {
    SegmentTracking.setStateImplementation($state);
    SegmentTracking.setLogImplementation(log);
    // We use $location for URL since $state.url is not always reliable.
    SegmentTracking.setLocationHrefGetter(() => $location.$$url);

    this.identify = SegmentTracking.identify;

    this.setAnonymousUserID = SegmentTracking.setAnonymousUserID;

    this.getAnonymousUserID = SegmentTracking.getAnonymousUserID;

    this.getUserID = SegmentTracking.getUserID;

    this.isIdentified = SegmentTracking.isIdentified;

    /**
     * Alias a user Id with a previous anonymous user we were tracking.
     * @param userId {number} ID of user to associate anonymous user/events to.
     */
    this.alias = SegmentTracking.alias;

    /**
     * Reset() dissociates future events that occur from the user currently identified.
     * When run, user_id is nullified and a new anonymousId is assigned to this visitor.
     *
     * This is typically executed on logout so non-logged-in events are no longer attributed to the user.
     * Without this, if the user logged out and registered a new account, segment would attribute
     * the signup step events to the user_id the visitor had before logging out.
     */
    this.reset = SegmentTracking.reset;

    /**
     * Logout user from tracking if already identified.
     */
    this.logoutIfAlreadyIdentified = SegmentTracking.logoutIfAlreadyIdentified;

    /**
     * Track an event.
     *
     * @param eventName Name of event.
     * @param properties Object with details about the event.
     */
    this.track = SegmentTracking.track;

    /**
     * Track a page view.
     *
     * @param name URL, path or other identifier for the page.
     */
    this.page = SegmentTracking.page;

    /**
     * Set the IP that will be sent to Segment to enable
     * country reporting.
     * @param currentIp IP, user's IP obtained from back-end. We anonymize by setting the last ocet set to zero.
     */
    this.setAnonymizedUserId = SegmentTracking.setAnonymizedUserId;

    /**
     * Set the country code that will be sent to Segment to enable
     * country reporting.
     * @param countryCode Country Code, user's country code Must be obatined from back-end.
     */
    this.setCountryCode = SegmentTracking.setCountryCode;
});
